import { gql } from '@apollo/client';
import { ErrorMessageInfo, ReferralInfoShared } from '../fragments';

export default gql`
  mutation actionReferralStatus($input: ReferralStatusActionInput!) {
    actionReferralStatus(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      referral {
        ...ReferralInfoShared
      }
    }
  }
  ${ReferralInfoShared}
  ${ErrorMessageInfo}
`;
